<!-- 支付成功页面 -->
<template>
	<div>
		<div v-if="localStorage.orderLineType == 'insite'">
			<div class="success">{{$t('OrderDetail.order0')}}</div>
			<van-button @click="$router.push('/OrderDetail/'+sessionStorage.actOrderId)" class="btn" block>{{$t('OrderDetail.view')}}</van-button>
		</div>
		<div v-if="localStorage.orderLineType == 'takeAway'">
			<div class="success">{{$t('OrderDetail.order0')}}</div>
			<van-button @click="$router.push('/TakeOrderDetail/'+localStorage.takeOrderId)" class="btn" block>{{$t('OrderDetail.view')}}</van-button>
		</div>
	</div>
</template>

<script>
export default {
  data () {
    return {
    };
  },
}

</script>
<style scoped>
	.success{
		height: 200px;
		text-align: center;
		line-height: 200px;
		font-size: 30px;
		color: #84D48D;
		font-weight: bold;
		background: #fff;
	}
	.btn{
		background: #2f75f4;
		color: #fff;
		margin:10px auto;
		width: 50%;
		border-radius: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Success.vue